import { LocalPlatformAdapter, type PlatformCapabilities } from "./PlatformAdapter";

/**
 * Placeholder for CrazyGames. Advertises the platform's intended capabilities
 * for UI wiring; methods stay no-ops (inherited) until the external CrazyGames
 * SDK (window.CrazyGames) is bound in a later phase. No SDK dependency imported.
 */
export class CrazyGamesPlatformAdapter extends LocalPlatformAdapter {
  getCapabilities(): PlatformCapabilities {
    return { ads: true, rewarded: true, banner: true, cloudSave: true, leaderboard: false };
  }
}
